// extracted by mini-css-extract-plugin
export var buttons = "buttons-module--buttons--Pgi6u";
export var buttonLink1 = "buttons-module--buttonLink1--3j5wi";
export var buttonLink2 = "buttons-module--buttonLink2--96lTl";